import React from 'react'

import lineBreak1 from '../../../assets/images/lineBreak1.png';
import lineBreak2 from '../../../assets/images/lineBreak2.png';

export default function LineBreak(props) {

    const type = [lineBreak1, lineBreak2];
    let typeNum = 0;
    props.type ? typeNum = props.type : typeNum = 0;

    return (
        <div style={{
            height: props.height,
            backgroundImage: `url(${type[typeNum]})`,
            backgroundPosition: 'center',
            backgroundRepeat: 'no-repeat',
            backgroundSize: '100% 100%',
            overflowX: "hidden",
        }}>
        </div>
    )
}
